module.exports = __webpack_public_path__ + "static/media/share.54774791.svg";